<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "edit" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 22 22'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M11 18.3332H19.25M2.75 18.3332H4.285C4.73341 18.3332 4.95762 18.3332 5.16862 18.2826C5.35568 18.2376 5.53451 18.1636 5.69855 18.0631C5.88356 17.9497 6.0421 17.7911 6.35918 17.4741L17.875 5.95822C18.6344 5.19882 18.6344 3.96761 17.875 3.20821C17.1156 2.44882 15.8844 2.44882 15.125 3.20821L3.60916 14.7241C3.29208 15.0411 3.13354 15.1997 3.02016 15.3847C2.91964 15.5487 2.84557 15.7276 2.80066 15.9146C2.75 16.1256 2.75 16.3498 2.75 16.7982V18.3332Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>